module.exports = "/work-site/img/envType.9f31d1c7.png";